import React from 'react';

import QuestionLabel from './Components/QuestionLabel';

export default function LongTextProperties({ question }) {
  return <QuestionLabel question={question} />
}